function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Descriptions, Divider, Radio, InputNumber, Alert, Tag, Upload } from 'antd';
import Common from "../includes/Common";
import { Upload as UploadIcon } from 'react-bootstrap-icons';
import { Container, Col, Row } from "react-bootstrap";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var SaveVisioData = function SaveVisioData(_ref) {
  var candidat = _ref.candidat,
    handler = _ref.handler;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormProcessing = _useState2[0],
    setIsFormProcessing = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    file = _useState6[0],
    setFile = _useState6[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var props = {
    onRemove: function onRemove(file) {
      setFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setFile(file);
      return false;
    },
    accept: ".pdf",
    maxCount: 1
  };
  var onFinish = function onFinish(values) {
    setErrorMessage('');
    setIsFormProcessing(true);
    var formData = new FormData();
    formData.append("user_id", Common.currentUser.id);
    formData.append("customer_id", candidat.id);
    formData.append("comment", values.comment);
    formData.append("attached_file", file);
    formData.append("binocular", values.binocular);
    formData.append("leftsight", values.leftsight);
    formData.append("rightsight", values.rightsight);
    formData.append("f_binocular", values.f_binocular);
    formData.append("f_leftsight", values.f_leftsight);
    formData.append("f_rightsight", values.f_rightsight);
    formData.append("colorseeing", values.colorseeing);
    formData.append("blowtest", values.blowtest);
    axios.post(Common.baseApiUrl + "setvisiodata", formData).then(function (response) {
      if (response.data.status == 200) {
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  useEffect(function () {
    if (candidat && candidat.visio_test != null) {
      form.setFieldsValue({
        comment: candidat.visio_test.comment,
        binocular: candidat.visio_test.binocular,
        leftsight: candidat.visio_test.leftsight,
        rightsight: candidat.visio_test.rightsight,
        colorseeing: candidat.visio_test.colorseeing,
        blowtest: candidat.visio_test.blowtest,
        peripheral: candidat.visio_test.peripheral
      });
    } else {
      form.setFieldsValue({
        comment: "",
        binocular: null,
        leftsight: null,
        rightsight: null,
        colorseeing: null,
        blowtest: null,
        peripheral: null
      });
    }
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        padding: "20px",
        background: "#B7693F",
        borderRadius: "0px 7px 7px 7px",
        color: "#FFFFFF"
      },
      children: ["Sauvegarder les donn\xE9s du Visio teste pour le candidat ", /*#__PURE__*/_jsx("b", {
        children: candidat.name
      })]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: errorMessage,
          banner: true
        })
      }), /*#__PURE__*/_jsx("h6", {
        children: "ACUITE VISUELLE DE PRES"
      }), /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 4,
            md: 4,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "f_binocular",
              label: "binoculaire ?",
              children: /*#__PURE__*/_jsx(InputNumber, {
                addonAfter: "/10"
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 4,
            md: 4,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "f_leftsight",
              label: "Oeil Gauche ?",
              children: /*#__PURE__*/_jsx(InputNumber, {
                addonAfter: "/10"
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 4,
            md: 4,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "f_rightsight",
              label: "Oeil droit ?",
              children: /*#__PURE__*/_jsx(InputNumber, {
                addonAfter: "/10"
              })
            })
          })]
        })
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("h6", {
        children: "ACUITE VISUELLE DE LOIN"
      }), /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 4,
            md: 4,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "binocular",
              label: "binoculaire ?",
              children: /*#__PURE__*/_jsx(InputNumber, {
                addonAfter: "/10"
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 4,
            md: 4,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "leftsight",
              label: "Oeil Gauche ?",
              children: /*#__PURE__*/_jsx(InputNumber, {
                addonAfter: "/10"
              })
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 4,
            md: 4,
            children: /*#__PURE__*/_jsx(Form.Item, {
              name: "rightsight",
              label: "Oeil droit ?",
              children: /*#__PURE__*/_jsx(InputNumber, {
                addonAfter: "/10"
              })
            })
          })]
        })
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("h6", {
        children: "VISION DES COULEURS"
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "colorseeing",
        children: /*#__PURE__*/_jsx(Radio.Group, {
          optionType: "button",
          buttonStyle: "solid",
          options: [{
            label: 'VALIDE',
            value: 1
          }, {
            label: 'NON VALIDE',
            value: 0
          }]
        })
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("h6", {
        children: "TESTE D'EBLOUISSEMENT"
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "blowtest",
        children: /*#__PURE__*/_jsx(Radio.Group, {
          optionType: "button",
          buttonStyle: "solid",
          options: [{
            label: 'VALIDE',
            value: 1
          }, {
            label: 'NON VALIDE',
            value: 0
          }]
        })
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("h6", {
        children: "CHAMPS PERIPHERIQUE"
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "peripheral",
        children: /*#__PURE__*/_jsx(Radio.Group, {
          optionType: "button",
          buttonStyle: "solid",
          options: [{
            label: 'VALIDE',
            value: 1
          }, {
            label: 'NON VALIDE',
            value: 0
          }]
        })
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Upload, _objectSpread(_objectSpread({}, props), {}, {
          children: /*#__PURE__*/_jsx(Button, {
            type: "primary",
            icon: /*#__PURE__*/_jsx(UploadIcon, {
              size: 20
            }),
            children: /*#__PURE__*/_jsx("b", {
              children: "JOINDRE UN FICHIER"
            })
          })
        }))
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "comment",
        label: "Commentaire",
        children: /*#__PURE__*/_jsx(Input.TextArea, {
          autoSize: {
            minRows: 9,
            maxRows: 12
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormProcessing,
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "VALIDER"
          })
        })
      })]
    })]
  });
};
export default SaveVisioData;